/**
 * @generated SignedSource<<76caefc1f9d36210a0e51da5d9c98535>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastScreenAdminEditNameQuery$variables = {
  screenId: string;
};
export type StorecastScreenAdminEditNameQuery$data = {
  readonly storecast: {
    readonly screen: {
      readonly name: string;
    };
  };
};
export type StorecastScreenAdminEditNameQuery = {
  response: StorecastScreenAdminEditNameQuery$data;
  variables: StorecastScreenAdminEditNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "screenId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminEditNameQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Storecast",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screen",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastScreenAdminEditNameQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Storecast",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screen",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "02e5ca056bb2e77d9db1a558648c6530",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminEditNameQuery",
    "operationKind": "query",
    "text": "query StorecastScreenAdminEditNameQuery(\n  $screenId: ID!\n) {\n  storecast {\n    screen(id: $screenId) {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a9263ab6d693137152cbbe818f50e60e";

export default node;
